import { useEffect, useRef, useState } from 'react'

/** One shared audio element for the console: starting a clip stops the last; the same key toggles. */
export function usePlayer<K extends string | number>() {
  const audio = useRef<HTMLAudioElement | null>(null)
  const [playing, setPlaying] = useState<K | null>(null)

  useEffect(() => () => audio.current?.pause(), [])

  function toggle(key: K, url: string) {
    audio.current?.pause()
    if (playing === key) return setPlaying(null)
    const el = new Audio(url)
    el.onended = () => setPlaying((k) => (k === key ? null : k))
    audio.current = el
    setPlaying(key)
    void el.play().catch(() => setPlaying(null))
  }

  return { playing, toggle }
}
